import React, {useEffect, useState} from "react";
import InputRange from 'react-input-range';
import "../../src/assets/css/multirange-slider.scss";
import 'react-input-range/lib/css/index.css';
import {isMobileOnly} from "react-device-detect";
import PropTypes from "prop-types";

const ShopMultiRangeDropSlider = ({ sortedHighPrice, sortedLowPrice, currentQuery, setCurrentQuery, isHome, isPhysio, setLoadingProducts }) => {
    const [minValue, set_minValue] = useState(0);
    const [maxValue, set_maxValue] = useState(1);
    const [selectedPriceValue, setSelectedPriceValue] = useState({min: sortedLowPrice, max: sortedHighPrice});
    const [hide, setHide] = useState(false)
    const [componentLoaded, setComponentLoaded] = useState(false)
    const [display, setDisplay] = useState('none')
    const [isSmallScreen, setSmallScreen] = useState(false);
    const [selectedPriceFinalValue, setSelectedPriceFinalValue] = useState({min: sortedLowPrice, max: sortedHighPrice});

    useEffect(() => {
        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        }
    }, [])

    useEffect(() => {
        set_maxValue(sortedHighPrice)
        set_minValue(sortedLowPrice)
        setSelectedPriceValue({min: currentQuery.lowDrop ? currentQuery.lowDrop : sortedLowPrice, max: currentQuery.highDrop ? currentQuery.highDrop : sortedHighPrice})
    }, [sortedHighPrice, sortedLowPrice, currentQuery])

    useEffect(() => {
        if(componentLoaded){
            setCurrentQuery({ ...currentQuery, lowDrop: selectedPriceFinalValue.min, highDrop: selectedPriceFinalValue.max});
        }
    }, [selectedPriceFinalValue, componentLoaded])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(true)
        }
    })

    useEffect(() => {
        if (hide) {
            setDisplay('none')
        } else {
            setDisplay('block')
        }
    }, [hide])

    useEffect(() => {
        if (isMobileOnly || isSmallScreen){
            setHide(false)
        }
    }, [isSmallScreen])

    return (
        <div className="sidebar-widget mt-10">
            <div>
                <h4 className="pro-sidebar-title">{
                    isPhysio && isHome ? "Quelle plage d'indice ? (facultatif)" : 
                    isHome ? "Quelle plage de drop ? (facultatif)" : 
                    isPhysio ? "Indice :" :
                    "Drop :"} &nbsp;
                </h4>
                <div className="sidebar-widget-tag-gender mt-20" style={{display: display}}>
                    { sortedHighPrice > 1 && maxValue > 1 && minValue >= 0 ?
                        <InputRange
                            draggableTrack
                            maxValue={sortedHighPrice}
                            minValue={sortedLowPrice}
                            step={1}
                            formatLabel={value => isPhysio ? `${value}` : `${value} mm`}
                            onChange={value => setSelectedPriceValue(value)}
                            onChangeComplete={value => {
                                setLoadingProducts(true)
                                setComponentLoaded(true)
                                setSelectedPriceFinalValue(value)
                                setSelectedPriceValue(value)}
                            }
                            value={selectedPriceValue}/>
                        :
                        null
                    }
                </div>
                <div>
                {
                    currentQuery && currentQuery.pains == "Douleur pied-mollet" && currentQuery.productSlug && currentQuery.productSlug !== ""?
                    <div style={{marginTop: "10px"}}>Pour atténuer la douleur du patient, nous recommandons de choisir une chaussure avec le même indice que la paire actuelle ou une dont l’indice est inférieur de maximum 20 %.</div>
                    : currentQuery && currentQuery.pains == "Douleur pied-mollet"?
                    <div style={{marginTop: "10px"}}>Pour atténuer la douleur du patient, nous recommandons de choisir une chaussure avec un indice compris entre 0 et {currentQuery.genders == "Men" ? "56" : "55"}.</div>
                    : currentQuery && currentQuery.pains == "Douleur genou-hanche-dos"  && currentQuery.productSlug && currentQuery.productSlug !== "" ?
                    <div style={{marginTop: "10px"}}>Pour atténuer la douleur du patient, nous recommandons de choisir une chaussure avec le même indice que la paire actuelle ou une dont l’indice est supérieur de maximum 15 %.</div>
                    : currentQuery && currentQuery.pains == "Douleur genou-hanche-dos"?
                    <div style={{marginTop: "10px"}}>Pour atténuer la douleur du patient, nous recommandons de choisir une chaussure avec un indice compris entre {currentQuery.genders == "Men" ? "57" : "56"} et 100.</div>
                    : currentQuery && currentQuery.pains == "Pas de douleur" && currentQuery.types == "Coureur débutant" ?
                    <div style={{marginTop: "10px"}}>Nous conseillons de proposer une chaussure n'ayant ni plaque carbone, ni plaque plastique, avec un indice similaire à la paire actuellement utilisée.</div>
                    : currentQuery && currentQuery.pains == "Pas de douleur" && currentQuery.types == "Coureur expérimenté" && currentQuery.analysis == "Entrainement"?
                    <div style={{marginTop: "10px"}}>Nous recommandons de proposer une paire avec un indice similaire, en incluant dans la sélection des modèles avec des plaques en plastique mais n'ayant pas de plaque en carbone.</div>
                    : currentQuery && currentQuery.pains == "Pas de douleur" && currentQuery.types == "Coureur expérimenté" && currentQuery.analysis == "Performance" ?
                    <div style={{marginTop: "10px"}}>Nous recommandons de proposer une paire avec un indice similaire à la paire actuelle, en incluant dans la sélection des modèles avec des plaques en carbone et en plastique.</div>
                    : null 
                }
                </div>
            </div>
        </div>
    );
};

ShopMultiRangeDropSlider.propTypes = {
    sortedHighPrice: PropTypes.any,
    sortedLowPrice: PropTypes.any,
    getSortParams: PropTypes.func
};

export default ShopMultiRangeDropSlider;